import { Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CONTACT_ERR_MSG, CustomValidator, EMAIL_VALIDATION_PATTERN, MULTILINGUAL_NAME_VALIDATION_PATTERN } from 'src/app/shared';
import { DriverService } from '@core/services/driver.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { CouponResponse } from '@core/models/promo-code.modal';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input-gg';
import { passwordValidator } from '@shared/services/custom-validatior.abstract';
import { ToastService } from '@shared/services/toast.service';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { CommonFunctions } from '@shared/common-functions';
import { PromoComeModalComponent } from './promo-come-modal/promo-come-modal.component';
import { autoUnsubWith } from '@shared/services/utility.abstract';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';
import { ConfigService } from '@core/services/config.service';
@Component({
  selector: 'app-driver-signup',
  templateUrl: './driver-signup.component.html',
  styleUrls: ['./driver-signup.component.scss']
})
export class DriverSignUpComponent implements  OnInit {
  readonly destroyRef = inject(DestroyRef);
  signupform: FormGroup;
  isSignUp: boolean = true;
  otpEmail: string
  loginInput: { email: string, mobile: string }
  showOtpComponent = false;
  verifiedOtp: string;
  separateDialCode = false;
	SearchCountryField = SearchCountryField;
	countryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
	preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  otp: string;
  showButton: boolean = false;
  countDown: string = '1:00';
  couponValidityData:CouponResponse;
  resendOtp:boolean = false;
  termsCondition = false;
  headerText: boolean = true;
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': '50px',
      'height': '50px'
    }
  };
  requiredLastNameAsterisk:boolean = false;

  constructor(private readonly fb: FormBuilder,
    private readonly driverService: DriverService,
    private readonly router: Router,
    private readonly ref: DynamicDialogRef,
    private readonly toastService: ToastService,
    public readonly dialogControlService: DialogControlService,
    private readonly encryptStorage: EncryptionStorageService,
    private readonly configService: ConfigService
  ) { }

  ngOnInit() {
    const { validators, required } = CommonFunctions.getLastNameValidators('driver', this.configService);    
    this.requiredLastNameAsterisk = required;
    this.signupform = this.fb.group({
      name: ['', [Validators.required, Validators.pattern(MULTILINGUAL_NAME_VALIDATION_PATTERN),Validators.minLength(3), Validators.maxLength(50),CommonFunctions.noLeadingSpacesValidator()]],
      lastName: ['', [...validators ,Validators.minLength(3),  Validators.pattern(MULTILINGUAL_NAME_VALIDATION_PATTERN),Validators.maxLength(50),CommonFunctions.noLeadingSpacesValidator()]],
      email: ['', [Validators.required, Validators.email, Validators.pattern(EMAIL_VALIDATION_PATTERN)]],
      Password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(15),passwordValidator]],
      ConfirmPassword: ['', [Validators.required,passwordValidator]],
      phone: new FormControl(undefined, [Validators.required]),
      deviceType: [3],
      promoOfferId: [null],
      termsCondition:[false]
    });
    
    window.scrollTo(0, 0);
    const isEmailVerified = this.encryptStorage.getItem('isEmailVerified');
    if (isEmailVerified == 'false') {
      this.showOtpComponent = true
      this.isSignUp = false
      this.loginInput = JSON.parse(this.encryptStorage.getItem('loginInput') || '{}');
      this.otpEmail = this.encryptStorage.getItem('email');
      this.sendOtp()
    }
  }

  openPromoCodeModal(){
    this.dialogControlService.openDialog(PromoComeModalComponent, {
      width: '40%',
    });

    this.dialogControlService.onClose().subscribe((data)=>{
      this.couponValidityData = data;
      this.signupform.get('promoOfferId').setValue(this.couponValidityData?.offerId)
      
    })
  }

   onlyNumberInput(event: KeyboardEvent): void {
    CommonFunctions.onlyNumberInput(event);
  }
  
  submit(): void {
    if (!this.termsCondition) {
      this.toastService.showToastMessage('error', 'Error', 'Please agree to the Terms & Conditions.');
      return;
    }

    if (!this.signupform.valid) {
      CustomValidator.markFormGroupTouched(this.signupform);
      return;
    }

    const formValue = this.signupform.value;

    if (!formValue.email && !formValue.phone) {
      this.toastService.showToastMessage('error', 'Error', CONTACT_ERR_MSG);
      return;
    }

    if (formValue.Password !== formValue.ConfirmPassword) {
      this.toastService.showToastMessage('error', 'Error', 'Confirm Password should match the Password');
      return;
    }

    this.otpEmail = formValue.email;

    const signupRequest = {
      email: formValue.email,
      name: formValue.name,
      lastName: formValue.lastName,
      password: formValue.Password,
      deviceType: 3,
      deviceId: '',
      fcmToken: '',
      profileImagePath: '',
      promoOfferId: this.couponValidityData?.offerId,
      mobileNumber: formValue.phone?.number || '',
      countryCode: formValue.phone?.dialCode || '',
      iso: formValue.phone?.countryCode || '',
    };

    this.driverService.createUser(signupRequest)
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (res) => {
          this.toastService.showToastMessage('success', 'Success', res.message);
          this.router.navigate(['login']);
        },
        error: (err: HttpErrorResponse) => {
          this.toastService.showToastMessage('error', 'Error', err.error.message);
          this.isSignUp = true;
          this.showOtpComponent = false;
        }
      });
  }

  sendOtp() {
    this.showButton = false;
    this.startCountDown()
    this.headerText = false;
    
    const req: any = {
      verificationFor: 1,
      email: this.otpEmail || this.loginInput?.email,
      requestCount: 0,
      mobileNumber: this.signupform.value?.phone?.number || this.loginInput?.mobile,
    }
    this.driverService.sendOtpForVerification(req).pipe(autoUnsubWith(this.destroyRef)).subscribe({
      next: (_res) => {
        if (_res) {

if(!this.resendOtp){
            this.toastService.showToastMessage('success', 'Success', _res.message);
          }else{
            this.toastService.showToastMessage('success', 'Success', 'Passcode resent successfully!');
          }
        }
      },
      error: (er: HttpErrorResponse) => {
        this.headerText = false;
        
        this.showButton = true;
        this.toastService.showToastMessage('error', 'Error', er.error.message);
      }

    });
  }
  onOtpChange(otp) {
    this.otp = otp;
  }
  verifyEmailByOTP() {
    
    const req: any = {
      email: this.otpEmail || this.loginInput?.email,
      mobileNumber: this.signupform.value?.phone?.number || this.loginInput?.mobile,
      otp: this.otp
    }

    this.driverService.verifyEmailByOTP(req)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (_res) => {
        if (_res.message) {
          
          this.toastService.showToastMessage('success', 'Success', 'Account verified successful!');
          localStorage.clear();
        }
        setTimeout(() => {
          this.router.navigate(['driver/create-booking']);
        }, 3000);
      }, error: (error: HttpErrorResponse) => {
        if (error) {
          
          if(error.error.message ==='Please send Passcode'){
            this.toastService.showToastMessage('error', 'Error', 'Please Enter Passcode');
          }else{
            this.toastService.showToastMessage('error', 'Error', error.error.message);
          }
        }
      }
    })
  }

  startCountDown() {
    let countDownDate = new Date();
    countDownDate.setMinutes(countDownDate.getMinutes() + 1);
    let countDownInterval = setInterval(() => {
      let now = new Date().getTime();
      let distance = countDownDate.getTime() - now;
      let minutes = Math.floor(distance / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);
      this.countDown = minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
      if (distance <= 0) {
        clearInterval(countDownInterval);
        this.countDown = '0:00';
        this.showButton = true;
      }
    }, 1000);
  }

  onClickSendOtp(event) {
    event.preventDefault();
    this.sendOtp();
    this.resendOtp = true;
  }

  onPasswordKeyDown(event: KeyboardEvent, controlName: string): void {
    const maxLength = 15;
    const control = this.signupform.get(controlName);
    const currentValueLength = control?.value.length ?? 0;
  
    if (currentValueLength >= maxLength && event.key !== 'Backspace' && event.key !== 'Delete') {
      event.preventDefault();
    }
  }

  cancel() {
      this.ref.close();
    }

    onCheckboxSelect(){
     this.termsCondition = !this.termsCondition
    }

}
